import React, { FunctionComponent, InputHTMLAttributes } from 'react';
import { UseFormMethods } from 'react-hook-form';
import PasswordInput from 'SharedComponents/PasswordInput';
import { Field } from 'SharedComponents/styled/forms/Field';

interface Props {
    passwordInputProps: InputHTMLAttributes<HTMLInputElement>;
    formApi: UseFormMethods;
    isLoading: boolean;
    isFolded: boolean;
}

const PasswordField: FunctionComponent<Props> = props => {
    const { isFolded, formApi, isLoading, passwordInputProps } = props;
    if (isFolded) {
        return <></>;
    }
    return (
        <Field>
            <PasswordInput formApi={formApi} readOnly={isLoading} {...passwordInputProps} />
        </Field>
    );
};

export default PasswordField;
